(function ($, w, d, undefined) {
  $('a').filter(function () {
    // console.log(this.hostname + ' =?= ' + dauphin_theme_vars.resalys_base_url)
    return this.hostname && this.hostname !== location.hostname && this.hostname !== dauphin_theme_vars.resalys_base_url.replace(/http[s]?:\/\//gi, '') || this.classList.contains('external')
  }).addClass('external').attr('target', '_blank')
}($, window, document))
